<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: fan.wu
 * @Date: 2020-04-08
 * @LastEditors: fan.wu
 * @LastEditTime: 2020-04-08
 -->
<template>
  <span>
    <div class="div-el-dalog" v-loading="loading">
      <div
        class="div-cancel"
        @click="close"
        style="position:absolute;width:3.125rem;right:0px;top:0.9375rem;z-index:2003"
      >
        <i class="el-icon-close"></i>
      </div>
      <div style="margin-bottom:0.9375rem">
        <el-steps :active="this.presentStep" align-center>
          <el-step
            v-for="(item, index) in stepList"
            :key="item.header"
            :title="'步骤' + (index + 1)"
            :description="item.header"
          ></el-step>
        </el-steps>
      </div>
      <el-form :model="form" label-width="5rem" >
        <el-form-item
          v-if="presentStepItem.type === 'COMPLETE'"
          :label="editItem.attributeName"
          :rules="[
            {
              required: true,
              message: `${editItem.attributeName}不能为空`
            }
          ]"
        >
          <el-input
            v-if="editItem.name === 'userPassword'"
            show-password
            v-model="presentStepItem.stepValue"
            :placeholder="presentStepItem.placeholder"
          ></el-input>
          <el-input
            v-else
            v-model="presentStepItem.stepValue"
            :placeholder="presentStepItem.placeholder"
          ></el-input>
        </el-form-item>

        <div v-if="presentStepItem.type === 'NEW' && editItem.name === 'userPassword'">
        <el-form-item
          :label="editItem.attributeName"
          :rules="[
            {
              required: true,
              message: `${editItem.attributeName}不能为空`
            }
          ]"
        >
          <el-input
            show-password
            v-model="presentStepItem.stepValue"
            :placeholder="presentStepItem.placeholder"
          ></el-input>
        </el-form-item>
        <div class="psw-stronger">
          <el-progress :percentage="percentage" style="width:12.5rem;margin-left:1.25rem;margin-top:0.625rem;margin-right:0.625rem;" :show-text="false" :color="customColors"></el-progress>
          <span style="display:inline;color:#7d7d7d;font-size:0.875rem;">{{currentPasswordStrength}}  (要求密码强度为：{{editItem.needStrength}})</span>
        </div>
        <el-form-item
        :label="'确认' + editItem.attributeName"
          :rules="[
            {
              required: true,
              message: `确认${editItem.attributeName}不能为空`
            }
          ]">
        <el-input
            show-password
            v-model="presentStepItem.stepValueSure"
            :placeholder="'请再次输入密码'"
          ></el-input>
        </el-form-item>
        </div>

        <div v-if="presentStepItem.type === 'NEW' && editItem.name !== 'userPassword'">
        <el-form-item
        :label="editItem.attributeName"
          :rules="[
            {
              required: true,
              message: `${editItem.attributeName}不能为空`
            }
          ]">
        <el-input
            v-model="presentStepItem.stepValue"
            :placeholder="presentStepItem.placeholder"
          ></el-input>
        </el-form-item>
        </div>

        <el-form-item
          v-if="presentStepItem.type === 'NEW_CAPTCHA'"
          :label="'验证码'"
          :rules="[
            {
              required: true,
              message: `验证码不能为空`
            }
          ]"
        >
          <el-input
                v-model="presentStepItem.stepValue"
                :placeholder="presentStepItem.placeholder"
              ></el-input>
        </el-form-item>

        <el-form-item
          v-if="presentStepItem.type === 'OLD_CAPTCHA'"
          :label="'验证码'"
          :rules="[
            {
              required: true,
              message: `验证码不能为空`
            }
          ]"
        >
        <el-row :gutter="20" style="display:flex;flex-direction:row">
          <el-col :span="16">
          <el-input
                v-model="presentStepItem.stepValue"
                :placeholder="presentStepItem.placeholder"
              ></el-input>
          </el-col>
          <el-col :span="8">
            <el-button type="primary" v-if="!oldCaptchaSendFlag" @click="didTapSendCaptcha">发送验证码</el-button>
            <el-button type="primary" v-else disabled>验证码已发送</el-button>
          </el-col>
        </el-row>
        </el-form-item>

        <el-button

          type="primary"
          @click="didTapSubmit"
          :loading="submitLoading"
          class="message-submit"
          >
          <span v-if="presentStep + 1 < stepList.length && stepList[presentStep + 1].type !== 'CAPTCHA'">下一步</span>
          <span v-if="(presentStep + 1 < stepList.length) && stepList[presentStep + 1].type === 'CAPTCHA'">获取验证码</span>
          <span v-if="presentStep + 1 === stepList.length">保存</span>
          </el-button
        >
      </el-form>
    </div>
  </span>
</template>

<script>
import { checkPassword } from '@/framework/util/util'
import { getStrenth } from '@/systemManage/framework/utils/tools'

export default {
  name: 'OptionWindow',
  props: ['editItem'],
  data() {
    return {
      loading: false,
      dialogFormVisible: true,
      stepList: [],
      presentStep: 0,
      presentStepItem: {},
      upData: {},
      modelData: {}, // 提交的数据集
      oldCaptchaSendFlag: false, // 旧账号验证码发送标志
      percentage: 0,
      currentPasswordStrength: '', // 当前密码强度  中文
      currentStrength: '', // 当前密码强度  1 2 3 4 5
      customColors: [
        { color: '#FF0000', percentage: 0 },
        { color: '#FF0000', percentage: 20 },
        { color: '#FF6347', percentage: 40 },
        { color: '#DAA520', percentage: 60 },
        { color: '#FFD700', percentage: 80 },
        { color: '#C0FF3E', percentage: 100 }
      ],
      form: {
        passwd: ''
      }
    }
  },
  watch: {
    'presentStepItem.stepValue': {
      handler() {
        let passScore = checkPassword(this.presentStepItem.stepValue)
        this.percentage = passScore < 20 ? 20 : passScore < 40 ? 40 : passScore < 60 ? 60 : passScore < 80 ? 80 : 100
        this.currentStrength = passScore < 20 ? '1' : passScore < 40 ? '2' : passScore < 60 ? '3' : passScore < 80 ? '4' : '5'
        this.currentPasswordStrength = getStrenth(this.currentStrength)
      }
    }
  },
  created() {},
  mounted() {
    let stepList = []
    let value = this.editItem.value
    var step = {}
    if (value) {
      switch (this.editItem.checkOldValue) {
        case 'NO_CHECK':
          break

        case 'CAPTCHA':
          step = {
            header: `请验证[${this.editItem.value}]`,
            title: '验证码',
            placeholder: `请输入验证码`,
            type: 'OLD_' + this.editItem.checkOldValue,
            stepValue: ''
          }
          stepList.push(step)
          break

        case 'COMPLETE':
          step = {
            header: this.editItem.name === 'userPassword' ? `请输入旧密码` : `请补全[${this.editItem.value}]`,
            title: this.editItem.attributeName,
            placeholder: `请输入${this.editItem.attributeName}`,
            type: this.editItem.checkOldValue,
            stepValue: ''
          }
          stepList.push(step)
          break
      }
    }
    stepList.push({
      header: `设置新的${this.editItem.attributeName}`,
      title: this.editItem.attributeName,
      placeholder: `请输入${this.editItem.attributeName}`,
      type: 'NEW',
      stepValue: '',
      prop: this.editItem.name
    })

    switch (this.editItem.checkNewValue) {
      case 'NO_CHECK':
        break

      case 'CAPTCHA':
        step = {
          header: `验证${this.editItem.attributeName}`,
          title: '验证码',
          placeholder: `请输入验证码`,
          type: 'NEW_' + this.editItem.checkNewValue,
          stepValue: ''
        }
        stepList.push(step)
        break

      case 'COMPLETE':
        step = {
          header: `请补全[${this.editItem.value}]`,
          title: this.editItem.attributeName,
          placeholder: `请输入${this.editItem.attributeName}`,
          type: this.editItem.checkNewValue,
          stepValue: ''
        }
        stepList.push(step)
        break
    }
    this.stepList = stepList
    this.presentStepItem = stepList[this.presentStep]
  },

  methods: {
    close() {
      this.$emit('hideWindow')
    },

    didTapSendCaptcha() {
      var params = {
        field: this.editItem.name
      }
      this.loading = true
      this.$http
        .post('/self/account/send-captcha/to-old', null, { params })
        .then(response => {
          this.oldCaptchaSendFlag = true
        })
        .catch(error => {
          this.$message.error(error.msg)
        })
        .finally(() => {
          this.loading = false
        })
    },

    didTapSubmit() {
      if (!this.presentStepItem.stepValue) {
        this.$message.error(this.presentStepItem.placeholder)
        return
      }
      if (this.presentStepItem.type === 'NEW' && this.presentStepItem.prop === 'userPassword' && !this.presentStepItem.stepValueSure) {
        this.$message.error('请输入确认密码')
        return
      }

      let passwordStrength = parseInt(this.editItem.passwordStrength)
      let currentStrength = parseInt(this.currentStrength)
      if (this.presentStepItem.type === 'NEW' && this.presentStepItem.prop === 'userPassword' && currentStrength < passwordStrength) {
        this.$message.error('密码强度不符合要求')
        return
      }

      if (this.presentStepItem.type === 'NEW' && this.presentStepItem.prop === 'userPassword' && this.presentStepItem.stepValueSure !== this.presentStepItem.stepValue) {
        this.$message.error('两次输入的密码不一致')
        return
      }

      var params = {}
      if (this.presentStepItem.type === 'NEW' && (this.presentStep + 1) === this.stepList.length) {
        // 当前步骤值
        params = {
          field: this.presentStepItem.prop,
          value: this.presentStepItem.stepValue
        }
        this.loading = true
        this.modelData = Object.assign(this.modelData, params)
        this.modifyAccount(this.modelData)
      } else if (this.presentStepItem.type === 'NEW' && (this.presentStep + 1) < this.stepList.length) {
        // 当前步骤值
        params = {
          field: this.presentStepItem.prop,
          value: this.presentStepItem.stepValue
        }
        this.loading = true
        this.$http
          .post('/self/account/send-captcha/to-new', null, { params })
          .then(response => {
            this.modelData = Object.assign(this.modelData, params)
            this.presentStep++
            this.presentStepItem = this.stepList[this.presentStep]
          })
          .catch(error => {
            this.$message.error(error.msg)
          })
          .finally(() => {
            this.loading = false
          })
      } else if (this.presentStepItem.type === 'OLD_CAPTCHA' || this.presentStepItem.type === 'COMPLETE') {
        let obj = {
          'validOldValueString': this.presentStepItem.stepValue
        }
        this.modelData = Object.assign(this.modelData, obj)
        this.presentStep++
        this.presentStepItem = this.stepList[this.presentStep]
      } else if (this.presentStepItem.type === 'NEW_CAPTCHA') {
        let obj = {
          'validNewValueString': this.presentStepItem.stepValue
        }
        this.modelData = Object.assign(this.modelData, obj)
        this.loading = true
        this.modifyAccount(this.modelData)
      }
    },

    modifyAccount(params) {
      this.$http
        .post('/self/account', null, { params })
        .then(response => {
          this.presentStep = 0
          this.close()
          this.$message.success('操作成功')
        })
        .catch(error => {
          this.$message.error(error.msg)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.div-el-dalog {
  z-index: 2002;
  width: 50%;
  background: #fff;
  position: relative;
  margin: 0 auto 3.125rem;
  margin-top: 9.375rem;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  padding: 6.25rem 3.125rem 6.25rem 3.125rem;
  display: flex;
  flex-direction: column;
}
.message-submit {
  margin-left: 50%;
  margin-top: 1.875rem;
  width: 18.75rem;
  transform: translateX(-9.375rem);
}
.psw-stronger{
  margin-bottom:1.875rem;
  margin-left: 1.25rem;
  display: flex;
}
</style>
